import {ContentDataInput, ContentInput} from "@dropDesk/presentation/pages/ticket/ui/form_create/inputs/styled";
import InputTextAreaWithBorder from "@dropDesk/presentation/components/inputs/input_textarea_with_border";
import React from "react";
import {TicketEntity} from "@dropDesk/domain/entities/ticket/ticket.entity";
import SelectSearchDescriptionStatic from "@dropDesk/presentation/components/inputs/select_search_description_static";
import {
    TicketsDescriptionStaticEntity
} from "@dropDesk/domain/entities/ticket_description_static/ticket_description_static.entity";
import {useBetween} from "use-between";
import {
    useModalSearchTicketsDescriptionStatic
} from "@dropDesk/presentation/pages/ticket_description_static/ui/modals/handle_change_visible";

const InputsProblemDescription = (
    {
        useProblemStatic,
        loading,
        ticket,
        handleAllChanges,
        errorMessageDescription,
        autoFocus,
        handleSelectDescriptionStatic,
    }: {
        useProblemStatic: boolean
        loading: boolean
        ticket: TicketEntity,
        handleAllChanges: (event: { target: { name: string; value: any; checked?: any; type: string } }) => void
        errorMessageDescription: string
        autoFocus?: boolean;
        handleSelectDescriptionStatic: (descriptionStatic: TicketsDescriptionStaticEntity) => void,
    }
) => {

    return (
        <ContentDataInput>
            <ContentInput>
                {!useProblemStatic && <InputTextAreaWithBorder
                    required={true}
                    autoFocus={autoFocus ?? false}
                    name='description'
                    size={65}
                    disabled={loading}
                    placeHolder={"Informe uma descrição do problema"}
                    messageError={errorMessageDescription}
                    label={"Descrição do problema"}
                    value={ticket.description}
                    onChange={handleAllChanges}
                />}
                {useProblemStatic &&
                    <div style={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center'}}>
                        <SelectSearchDescriptionStatic
                            required={true}
                            size={37}
                            label={'Problema estático'}
                            placeHolder={"Selecione um problema"}
                            handleSelectDescriptionStatic={(value, descriptionStatic) => {
                                if (descriptionStatic) {
                                    handleSelectDescriptionStatic(descriptionStatic);
                                }
                            }}
                            handleSaveNewDescriptionStatic={(descriptionStatic) => handleSelectDescriptionStatic(descriptionStatic)}
                            value={ticket.descriptionStatic ? {
                                value: ticket.descriptionStatic.id,
                                label: ticket.descriptionStatic.description
                            } : undefined}
                            disabled={loading}
                            messageError={errorMessageDescription}
                        />
                    </div>
                }
            </ContentInput>
        </ContentDataInput>
    )
}
export default InputsProblemDescription;
